import React from 'react';
import { Alert, Button, Stack, Text, Title, Center, Paper } from '@mantine/core';
import { IconRefresh, IconAlertTriangle } from '@tabler/icons-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(_error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // 記錄錯誤到控制台和錯誤追蹤服務
    console.error('ErrorBoundary 捕獲到錯誤:', error, errorInfo);
    
    this.setState({
      error,
      errorInfo
    });

    // 這裡可以添加錯誤追蹤服務，例如 Sentry
    // trackError(error, errorInfo);
  }

  handleReload = () => {
    // 重新載入頁面
    window.location.reload();
  };

  handleReset = () => {
    // 重置錯誤狀態
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      // 錯誤 UI
      return (
        <Center style={{ minHeight: '100vh', padding: '20px' }}>
          <Paper shadow="md" radius="lg" p="xl" style={{ maxWidth: '500px', width: '100%' }}>
            <Stack align="center" gap="lg">
              <IconAlertTriangle size={64} color="var(--mantine-color-red-6)" />
              
              <Title order={2} c="red" ta="center">
                系統發生錯誤
              </Title>
              
              <Text size="lg" c="dimmed" ta="center">
                很抱歉，應用程式遇到了未預期的錯誤。請嘗試重新載入頁面。
              </Text>

              {/* 開發環境下顯示詳細錯誤資訊 */}
              {process.env.NODE_ENV === 'development' && this.state.error && (
                <Alert 
                  color="red" 
                  title="錯誤詳情（僅開發環境顯示）"
                  icon={<IconAlertTriangle size={16} />}
                >
                  <Text size="sm" style={{ fontFamily: 'monospace' }}>
                    {this.state.error.toString()}
                  </Text>
                  {this.state.errorInfo && (
                    <details style={{ marginTop: '8px' }}>
                      <summary>堆疊追蹤</summary>
                      <pre style={{ fontSize: '12px', overflow: 'auto', maxHeight: '200px' }}>
                        {this.state.errorInfo.componentStack}
                      </pre>
                    </details>
                  )}
                </Alert>
              )}

              <Stack gap="sm" w="100%">
                <Button 
                  onClick={this.handleReload}
                  leftSection={<IconRefresh size={16} />}
                  size="lg"
                  fullWidth
                >
                  重新載入頁面
                </Button>
                
                <Button 
                  variant="outline" 
                  onClick={this.handleReset}
                  size="lg"
                  fullWidth
                >
                  嘗試恢復
                </Button>
              </Stack>

              <Text size="sm" c="dimmed" ta="center">
                如果問題持續發生，請聯繫系統管理員
              </Text>
            </Stack>
          </Paper>
        </Center>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
